import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'menuButton', 'menuIcon']

  toggle() {
    const isOpen = this.menuTarget.classList.contains('is-open')

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.add('is-open')
    this.menuButtonTarget.setAttribute('aria-expanded', 'true')
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.menuTarget.classList.remove('is-open')
    this.menuButtonTarget.setAttribute('aria-expanded', 'false')
    document.body.style.overflow = ''
  }
}
